<div class="card">

  <div class="card-header text-center bg-primary text-white">
    <div class="row">
      <div class="col-1">&nbsp;</div>
      <div class="col-10">
        <h4>CPG Registration</h4>
      </div>
      <div class="col-1">
        <i-bs class="text-light float-end cursor-pointer" name="xCircle" (click)="onClose()"></i-bs>
      </div>
    </div>
  </div>

  <div class="card-body pb-0">
    <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()">
      <div class="row pb-3">
        <div class="col-12 col-md-6 mb-3">
          <label class="form-label text-primary" for="firstName">First Name</label>
          <input type="text" formControlName="firstName" id="firstName" class="form-control" placeholder="" />

          <div *ngIf="registrationForm.get('firstName').invalid && (registrationForm.get('firstName').dirty || registrationForm.get('firstName').touched)" class="text-danger">
            <div *ngIf="registrationForm.get('firstName').errors.required">
              First Name is required
            </div>
            <div *ngIf="registrationForm.get('firstName').errors.minlength">
              First Name cannot be more than 30 characters long
            </div>
            <div *ngIf="registrationForm.get('firstName').errors.minlength">
              First Name must be at least 3 characters long
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6 mb-3">
          <label class="form-label text-primary" for="lastName">Last Name</label>
          <input type="text" formControlName="lastName" id="lastName" class="form-control" placeholder="" />

          <div *ngIf="registrationForm.get('lastName').invalid && (registrationForm.get('lastName').dirty || registrationForm.get('lastName').touched)" class="text-danger">
            <div *ngIf="registrationForm.get('lastName').errors.required">
              Last Name is required
            </div>
            <div *ngIf="registrationForm.get('lastName').errors.minlength">
              Last Name cannot be more than 30 characters long
            </div>
            <div *ngIf="registrationForm.get('lastName').errors.minlength">
              Last Name must be at least 3 characters long.
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6 mb-3">
          <label class="form-label text-primary" for="company">Company</label>
          <input type="text" formControlName="company" id="company" class="form-control" placeholder="" />

          <div *ngIf="registrationForm.get('company').invalid && (registrationForm.get('company').dirty || registrationForm.get('company').touched)" class="text-danger">
            <div *ngIf="registrationForm.get('company').errors.required">
              Company Name is required
            </div>
            <div *ngIf="registrationForm.get('company').errors.minlength">
              Company Name cannot be more than 30 characters long
            </div>
            <div *ngIf="registrationForm.get('company').errors.minlength">
              Company Name must be at least 3 characters long
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6 mb-3">
          <label class="form-label text-primary" for="email">Email</label>
          <input type="email" formControlName="email" id="email" class="form-control" placeholder="" />

          <div *ngIf="registrationForm.get('email').invalid && (registrationForm.get('email').dirty || registrationForm.get('email').touched)" class="text-danger">
            <div *ngIf="registrationForm.get('email').errors.required">
              Email is required
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6 mb-3">
          <label class="form-label text-primary" for="phone">Phone</label>
          <input type="number" formControlName="phone" id="phone" class="form-control" placeholder="" />

          <div *ngIf="registrationForm.get('phone').invalid && (registrationForm.get('phone').dirty || registrationForm.get('phone').touched)" class="text-danger">
            <div *ngIf="registrationForm.get('phone').errors.required">
              Phone is required
            </div>
          </div>
        </div>
      </div>

      <div class="row text-center bg-light pt-3 pb-3">
        <div class="col">
          <button type="submit" class="btn btn-secondary text-white fw-bold" style="padding-left: 2.5rem; padding-right: 2.5rem;" [disabled]="buttonLoader">
            Register
            <div class="spinner-border spinner-border-sm" role="status" *ngIf="buttonLoader"></div>
          </button>
        </div>
      </div>
    </form>
  </div>

</div>
